/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Tag } from 'antd';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ROUTER } from '../../../constants/router';
import useQuery from '../../../util/useQuery';
import { t } from 'i18next';
export default function TabDetail({ riskRegisterOptions, riskInfo }) {
    const navigate = useNavigate();
    const params = useQuery();
    let { riskId, menu } = useParams();
    const [subOptionMode, setSubOptionMode] = useState(false);

    const location = useLocation();
    const mode = location?.state?.mode;
    const activityId = location?.state?.activityId;

    useEffect(() => {
        setSubOptionMode(false);
    }, [params.get('tab')]);

    useEffect(() => {
        if (riskRegisterOptions?.length > 0) {
            riskRegisterOptions.forEach((option) => {
                if (option.riskRegisterSubOptions?.length > 0) {
                    setSubOptionMode(true);
                }
            });
        }
    }, [riskRegisterOptions, params.get('tab')]);

    const validateBtn = (e, riskInfo) => {
        if (mode === 'clone' || mode === 'connect' || mode === 'view') {
            return t('RR.ViewDetail');
        } else {
            if (riskInfo.statusEn === 'Waiting for Review') {
                return t('RR.ViewDetail');
            } else {
                if (e.id) {
                    return t('Edit');
                }
            }
            return t('Select');
        }
    };

    return (
        <>
            {!subOptionMode ? (
                <div className="bg-white h-max rounded-xl p-4 py-6">
                    <div className="flex justify-between items-center mb-4">
                        <div>{t('RR.PleaseSpecifyRiskFactors')}</div>
                        <div className="flex items-center">
                            <svg
                                width="20"
                                height="21"
                                viewBox="0 0 20 21"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle
                                    cx="10"
                                    cy="10.5"
                                    r="10"
                                    fill="#4ACE8F"
                                />
                                <path
                                    d="M14.473 7.30657C14.411 7.24409 14.3373 7.19449 14.256 7.16065C14.1748 7.1268 14.0876 7.10938 13.9996 7.10938C13.9116 7.10938 13.8245 7.1268 13.7433 7.16065C13.662 7.19449 13.5883 7.24409 13.5263 7.30657L8.55964 12.2799L6.47297 10.1866C6.40863 10.1244 6.33267 10.0755 6.24943 10.0427C6.16619 10.0099 6.07731 9.99385 5.98786 9.99539C5.8984 9.99694 5.81013 10.0161 5.72808 10.0518C5.64602 10.0874 5.5718 10.1389 5.50964 10.2032C5.44748 10.2676 5.39861 10.3435 5.3658 10.4268C5.333 10.51 5.31691 10.5989 5.31846 10.6884C5.32001 10.7778 5.33916 10.8661 5.37482 10.9481C5.41049 11.0302 5.46196 11.1044 5.52631 11.1666L8.08631 13.7266C8.14828 13.7891 8.22202 13.8387 8.30326 13.8725C8.3845 13.9063 8.47163 13.9238 8.55964 13.9238C8.64765 13.9238 8.73479 13.9063 8.81603 13.8725C8.89727 13.8387 8.971 13.7891 9.03297 13.7266L14.473 8.28657C14.5406 8.22415 14.5946 8.14838 14.6316 8.06404C14.6685 7.97971 14.6876 7.88864 14.6876 7.79657C14.6876 7.70451 14.6685 7.61344 14.6316 7.5291C14.5946 7.44477 14.5406 7.369 14.473 7.30657V7.30657Z"
                                    fill="white"
                                />
                            </svg>
                            <span>&nbsp;&nbsp;</span>
                            {t('RR.InformationRA')}
                        </div>
                    </div>
                    {riskRegisterOptions?.map((options, i) => (
                        <div
                            className="flex justify-between items-center p-4 mb-4 box-content"
                            key={i}
                        >
                            <div className="flex items-center">
                                {options.isUse ? (
                                    <>
                                        <svg
                                            width="20"
                                            height="21"
                                            viewBox="0 0 20 21"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <circle
                                                cx="10"
                                                cy="10.5"
                                                r="10"
                                                fill="#4ACE8F"
                                            />
                                            <path
                                                d="M14.473 7.30657C14.411 7.24409 14.3373 7.19449 14.256 7.16065C14.1748 7.1268 14.0876 7.10938 13.9996 7.10938C13.9116 7.10938 13.8245 7.1268 13.7433 7.16065C13.662 7.19449 13.5883 7.24409 13.5263 7.30657L8.55964 12.2799L6.47297 10.1866C6.40863 10.1244 6.33267 10.0755 6.24943 10.0427C6.16619 10.0099 6.07731 9.99385 5.98786 9.99539C5.8984 9.99694 5.81013 10.0161 5.72808 10.0518C5.64602 10.0874 5.5718 10.1389 5.50964 10.2032C5.44748 10.2676 5.39861 10.3435 5.3658 10.4268C5.333 10.51 5.31691 10.5989 5.31846 10.6884C5.32001 10.7778 5.33916 10.8661 5.37482 10.9481C5.41049 11.0302 5.46196 11.1044 5.52631 11.1666L8.08631 13.7266C8.14828 13.7891 8.22202 13.8387 8.30326 13.8725C8.3845 13.9063 8.47163 13.9238 8.55964 13.9238C8.64765 13.9238 8.73479 13.9063 8.81603 13.8725C8.89727 13.8387 8.971 13.7891 9.03297 13.7266L14.473 8.28657C14.5406 8.22415 14.5946 8.14838 14.6316 8.06404C14.6685 7.97971 14.6876 7.88864 14.6876 7.79657C14.6876 7.70451 14.6685 7.61344 14.6316 7.5291C14.5946 7.44477 14.5406 7.369 14.473 7.30657V7.30657Z"
                                                fill="white"
                                            />
                                        </svg>
                                        <span>&nbsp;&nbsp;</span>
                                    </>
                                ) : (
                                    <span className="pl-7"></span>
                                )}
                                <h3 className="font-semibold mb-0">
                                    {options?.riskFactorOptionName}
                                </h3>
                                <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>

                                {options?.id && (
                                    <Tag
                                        className="rounded-xl -my-1 text-center px-2 text-white"
                                        style={{
                                            background: `${options?.riskPointColor}`,
                                            borderColor: `${options?.riskPointColor}`,
                                        }}
                                    >
                                        {options?.riskPoint
                                            ? options?.riskPoint
                                            : '-'}{' '}
                                        :{' '}
                                        {options?.riskPointDesc
                                            ? options?.riskPointDesc
                                            : '-'}
                                    </Tag>
                                )}
                            </div>
                            <div>
                                <Button
                                    type="primary"
                                    style={{
                                        padding: '0px 30px',
                                        background: '#ffff',
                                    }}
                                    onClick={() => {
                                        const path =
                                            menu !== 'ra'
                                                ? `${ROUTER.RISK_MANAGEMENT.RR}/${riskId}`
                                                : `${ROUTER.RISK_MANAGEMENT.RA}/ra/risk-register/${riskId}`;
                                        navigate(
                                            `${path}/${options.riskFactorOptionId}`,
                                            {
                                                state: {
                                                    riskInfo,
                                                    options,
                                                    subOption: null,
                                                    mode,
                                                    activityId,
                                                },
                                            }
                                        );
                                    }}
                                    size="large"
                                    ghost
                                >
                                    {validateBtn(options, riskInfo)}
                                </Button>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <>
                    {riskRegisterOptions?.map((options, i) => (
                        <div
                            className="bg-white h-max rounded-xl p-4 py-6 mb-4"
                            key={i}
                        >
                            <div className="text-lg font-bold">
                                {options?.riskFactorOptionName
                                    ? options?.riskFactorOptionName
                                    : '-'}
                            </div>
                            <div className="flex justify-between items-center mb-4">
                                <div>{t('RR.SpecifyRiskFactors')}</div>
                                <div className="flex items-center">
                                    <svg
                                        width="20"
                                        height="21"
                                        viewBox="0 0 20 21"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle
                                            cx="10"
                                            cy="10.5"
                                            r="10"
                                            fill="#4ACE8F"
                                        />
                                        <path
                                            d="M14.473 7.30657C14.411 7.24409 14.3373 7.19449 14.256 7.16065C14.1748 7.1268 14.0876 7.10938 13.9996 7.10938C13.9116 7.10938 13.8245 7.1268 13.7433 7.16065C13.662 7.19449 13.5883 7.24409 13.5263 7.30657L8.55964 12.2799L6.47297 10.1866C6.40863 10.1244 6.33267 10.0755 6.24943 10.0427C6.16619 10.0099 6.07731 9.99385 5.98786 9.99539C5.8984 9.99694 5.81013 10.0161 5.72808 10.0518C5.64602 10.0874 5.5718 10.1389 5.50964 10.2032C5.44748 10.2676 5.39861 10.3435 5.3658 10.4268C5.333 10.51 5.31691 10.5989 5.31846 10.6884C5.32001 10.7778 5.33916 10.8661 5.37482 10.9481C5.41049 11.0302 5.46196 11.1044 5.52631 11.1666L8.08631 13.7266C8.14828 13.7891 8.22202 13.8387 8.30326 13.8725C8.3845 13.9063 8.47163 13.9238 8.55964 13.9238C8.64765 13.9238 8.73479 13.9063 8.81603 13.8725C8.89727 13.8387 8.971 13.7891 9.03297 13.7266L14.473 8.28657C14.5406 8.22415 14.5946 8.14838 14.6316 8.06404C14.6685 7.97971 14.6876 7.88864 14.6876 7.79657C14.6876 7.70451 14.6685 7.61344 14.6316 7.5291C14.5946 7.44477 14.5406 7.369 14.473 7.30657V7.30657Z"
                                            fill="white"
                                        />
                                    </svg>
                                    <span>&nbsp;&nbsp;</span>
                                    {t('RR.InformationRA')}
                                </div>
                            </div>

                            {options.riskRegisterSubOptions.length > 0 &&
                                options.riskRegisterSubOptions?.map(
                                    (subOption, i) => (
                                        <div
                                            className="flex justify-between items-center p-4 mb-4 box-content"
                                            key={i}
                                        >
                                            <div className="flex items-center">
                                                {subOption.isUse ? (
                                                    <>
                                                        <svg
                                                            width="20"
                                                            height="21"
                                                            viewBox="0 0 20 21"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <circle
                                                                cx="10"
                                                                cy="10.5"
                                                                r="10"
                                                                fill="#4ACE8F"
                                                            />
                                                            <path
                                                                d="M14.473 7.30657C14.411 7.24409 14.3373 7.19449 14.256 7.16065C14.1748 7.1268 14.0876 7.10938 13.9996 7.10938C13.9116 7.10938 13.8245 7.1268 13.7433 7.16065C13.662 7.19449 13.5883 7.24409 13.5263 7.30657L8.55964 12.2799L6.47297 10.1866C6.40863 10.1244 6.33267 10.0755 6.24943 10.0427C6.16619 10.0099 6.07731 9.99385 5.98786 9.99539C5.8984 9.99694 5.81013 10.0161 5.72808 10.0518C5.64602 10.0874 5.5718 10.1389 5.50964 10.2032C5.44748 10.2676 5.39861 10.3435 5.3658 10.4268C5.333 10.51 5.31691 10.5989 5.31846 10.6884C5.32001 10.7778 5.33916 10.8661 5.37482 10.9481C5.41049 11.0302 5.46196 11.1044 5.52631 11.1666L8.08631 13.7266C8.14828 13.7891 8.22202 13.8387 8.30326 13.8725C8.3845 13.9063 8.47163 13.9238 8.55964 13.9238C8.64765 13.9238 8.73479 13.9063 8.81603 13.8725C8.89727 13.8387 8.971 13.7891 9.03297 13.7266L14.473 8.28657C14.5406 8.22415 14.5946 8.14838 14.6316 8.06404C14.6685 7.97971 14.6876 7.88864 14.6876 7.79657C14.6876 7.70451 14.6685 7.61344 14.6316 7.5291C14.5946 7.44477 14.5406 7.369 14.473 7.30657V7.30657Z"
                                                                fill="white"
                                                            />
                                                        </svg>
                                                        <span>
                                                            &nbsp;&nbsp;
                                                        </span>
                                                    </>
                                                ) : (
                                                    <span className="pl-7"></span>
                                                )}
                                                <h3 className="font-semibold mb-0">
                                                    {
                                                        subOption.riskFactorSubOptionName
                                                    }
                                                </h3>
                                                <span>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                                </span>

                                                {subOption.id && (
                                                    <Tag
                                                        className="rounded-xl -my-1 text-center px-2 text-white"
                                                        style={{
                                                            background: `${subOption.riskPointColor}`,
                                                            borderColor: `${subOption.riskPointColor}`,
                                                        }}
                                                    >
                                                        {subOption.riskPoint} :{' '}
                                                        {
                                                            subOption.riskPointDesc
                                                        }
                                                    </Tag>
                                                )}
                                            </div>
                                            <div>
                                                <Button
                                                    type="primary"
                                                    style={{
                                                        padding: '0px 30px',
                                                        background: '#ffff',
                                                    }}
                                                    onClick={() => {
                                                        const path =
                                                            menu !== 'ra'
                                                                ? `${ROUTER.RISK_MANAGEMENT.RR}/${riskId}`
                                                                : `${ROUTER.RISK_MANAGEMENT.RA}/ra/risk-register/${riskId}`;
                                                        navigate(
                                                            `${path}/${subOption.riskFactorSubOptionId}`,
                                                            {
                                                                state: {
                                                                    riskInfo,
                                                                    options,
                                                                    subOption,
                                                                    mode,
                                                                    activityId,
                                                                },
                                                            }
                                                        );
                                                    }}
                                                    size="large"
                                                    ghost
                                                >
                                                    {validateBtn(
                                                        subOption,
                                                        riskInfo
                                                    )}
                                                </Button>
                                            </div>
                                        </div>
                                    )
                                )}
                        </div>
                    ))}
                </>
            )}
        </>
    );
}
